import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

const FAQS = [
  {
    q: "Gli integratori sportivi sono davvero necessari?",
    a: "No, non sono indispensabili. La base resta sempre alimentazione, allenamento e sonno. Quando l'introito da cibo non basta a coprire i fabbisogni, alcuni integratori evidence-based — proteine, creatina, caffeina, omega-3, vitamina D — possono colmare lacune e migliorare la performance. Il mio approccio è: prima il piatto, poi l'integratore.",
  },
  {
    q: "Quanto dura un percorso di ricomposizione corporea?",
    a: "Un ciclo significativo richiede minimo 12–16 settimane. Un percorso completo può durare 4–9 mesi a seconda del punto di partenza, della genetica e dell'aderenza. Lavoriamo per fasi misurate, non per sprint dimagranti.",
  },
  {
    q: "Devo pesare ogni alimento?",
    a: "Nella fase iniziale pesare gli alimenti è essenziale per costruire l'occhio: serve a capire davvero le porzioni e i macro che stai assumendo. Dopo qualche mese sarai in grado di gestire le porzioni in modo molto più intuitivo, anche al ristorante.",
  },
  {
    q: "Lavori con atleti professionisti o solo amatori?",
    a: "Entrambi. Collaboro con sportivi di powerlifting, bodybuilding, maratona, ciclismo, calcio e nuoto. Con atleti agonisti integro periodizzazione di gara, controlli ematici e protocolli pre/intra/post competizione.",
  },
];

export const FAQ = () => {
  return (
    <section id="faq" data-testid="faq-section" className="relative bg-white py-20 md:py-28">
      <div className="max-w-[1280px] mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-4">
            <div className="text-xs uppercase tracking-[0.22em] text-[#1F6E45] font-bold mb-4">
              · FAQ
            </div>
            <h2 className="font-display text-[#0E1A14] text-3xl md:text-4xl lg:text-5xl tracking-tight leading-[1.05]">
              Domande
              <br />
              <span className="text-[#1F6E45]">frequenti.</span>
            </h2>
            <p className="mt-5 text-[#4A5A52] text-base leading-relaxed">
              Risposte rapide su integrazione, timing dei nutrienti e
              flessibilità metabolica. Per dubbi specifici, scrivimi su
              WhatsApp.
            </p>
          </div>

          <div className="lg:col-span-8">
            <Accordion
              type="single"
              collapsible
              className="bg-[#F7F9F7] border border-[#E1E7E3] rounded-2xl overflow-hidden"
              data-testid="faq-accordion"
            >
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border-b border-[#E1E7E3] last:border-0 px-6 md:px-7"
                >
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="text-left hover:no-underline py-5 md:py-6 text-base md:text-lg text-[#0E1A14] font-heading font-semibold tracking-tight hover:text-[#1F6E45] transition-colors [&[data-state=open]]:text-[#1F6E45] [&>svg]:text-[#1F6E45]"
                  >
                    <span className="flex items-center gap-4 pr-4">
                      <span className="font-display text-xs text-[#1F6E45] tracking-[0.2em]">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      {f.q}
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="text-[#4A5A52] text-base leading-relaxed pb-6 pl-12 pr-2">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};
